import React from 'react';

function LinkYear({ data, selectedYear, onYearChange }) {
    const handleClick = (event) => {
        const year = event.currentTarget.getAttribute('data-year');
        onYearChange(year);
    };

    return (
        <div className="all-year">
            {data.map(item => (
                <div
                    className={`year-box ${selectedYear === item.desc ? 'act' : ''}`}
                    key={item.ID}
                    data-year={item.desc}
                    onClick={handleClick}
                >
                    {item.name}
                </div>
            ))}
        </div>
    );
}

export default LinkYear;